const state = {
  userIdentity: "",
  userId: 0,
  userAppId: 0,
  // HTECH-SKIPMA
  userCategory: 0,
  isAuthenticated: false
}

const mutations = {
  UPDATE_USER_IDENTITY(state, userIdentity) {
    state.userIdentity = userIdentity
  },
  UPDATE_USER_ID(state, userId) {
    state.userId = userId
  },
  UPDATE_USER_APP_ID(state, userAppId) {
    state.userAppId = userAppId
  },
  // HTECH-SKIPMA
  UPDATE_USER_CATEGORY(state, userCategory) {
    state.userCategory = userCategory
  },
  UPDATE_IS_AUTHENTICATED(state, isAuthenticated) {
    state.isAuthenticated = isAuthenticated
  },
}

const actions = {
  updateUserIdentity({
    commit
  }, userIdentity) {
    commit('UPDATE_USER_IDENTITY', userIdentity);
  },
  updateUserId({
    commit
  }, userId) {
    commit('UPDATE_USER_ID', userId);
  },
  updateUserAppId({
    commit
  }, userAppId) {
    commit('UPDATE_USER_APP_ID', userAppId);
  },
  // HTECH-SKIPMA
  updateUserCategory({
    commit
  }, userCategory) {
    commit('UPDATE_USER_CATEGORY', userCategory);
  },
  updateIsAuthenticated({
    commit
  }, isAuthenticated) {
    commit('UPDATE_IS_AUTHENTICATED', isAuthenticated);
  },
}

const getters = {
  UserIdentity: state => {
    return state.userIdentity
  },
  UserId: state => {
    return state.userId
  },
  UserAppId: state => {
    return state.userAppId
  },
  // HTECH-SKIPMA
  UserCategory: state => {
    return state.userCategory
  },
  IsAuthenticated: state => {
    return state.isAuthenticated
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
